import { Box, Card, CardContent, Chip, Stack, Typography, Rating, Modal, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useState } from 'react'
import { motion } from 'framer-motion'

export const ReviewGalleryItem = ({ review }) => {
  const [open, setOpen] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState(null)

  const handleOpen = (media) => {
    setSelectedMedia(media)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedMedia(null)
  }

  return (
    <>
      <motion.div
        whileHover={{ scale: 1.05 }}
        transition={{ type: 'spring', stiffness: 300 }}
      >
        <Card
          sx={{
            height: '100%',
            cursor: 'pointer',
            transition: 'all 0.3s',
            overflow: 'hidden',
            '&:hover': {
              boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)'
            }
          }}
        >
          {/* Media Thumbnail */}
          <Box
            sx={{
              position: 'relative',
              height: '250px',
              backgroundColor: '#f0f0f0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}
            onClick={() => handleOpen(review.photoUrls?.[0] || review.videoUrl)}
          >
            {review.photoUrls && review.photoUrls.length > 0 ? (
              <Box
                component="img"
                src={review.photoUrls[0]}
                alt="Review"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  cursor: 'pointer'
                }}
              />
            ) : review.videoUrl ? (
              <Box
                component="video"
                src={review.videoUrl}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  cursor: 'pointer'
                }}
              />
            ) : (
              <Typography color="textSecondary">No media available</Typography>
            )}
            {review.photoUrls && review.photoUrls.length > 1 && (
              <Chip 
                label={`+${review.photoUrls.length - 1}`}
                sx={{
                  position: 'absolute',
                  bottom: 10,
                  right: 10,
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  color: 'white'
                }}
              />
            )}
          </Box>

          {/* Review Info */}
          <CardContent>
            <Stack spacing={2}>
              {/* Rating */}
              <Rating value={review.rating} readOnly size="small" />

              {/* Comment */}
              <Typography 
                variant="body2" 
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  minHeight: '2.4em'
                }}
              >
                {review.comment}
              </Typography>

              {/* User Name */}
              <Typography 
                variant="caption" 
                sx={{ 
                  fontWeight: 600,
                  color: 'primary.main'
                }}
              >
                {review.user?.name || 'Anonymous'}
              </Typography>

              {/* Date */}
              <Typography variant="caption" color="textSecondary">
                {new Date(review.createdAt).toLocaleDateString()}
              </Typography>

              {/* Media Count Badge */}
              {(review.photoUrls?.length || review.videoUrl) && (
                <Stack direction="row" spacing={1}>
                  {review.photoUrls && review.photoUrls.length > 0 && (
                    <Chip
                      label={`📷 ${review.photoUrls.length}`}
                      size="small"
                      variant="outlined"
                    />
                  )}
                  {review.videoUrl && (
                    <Chip
                      label="🎥 Video"
                      size="small"
                      variant="outlined"
                    />
                  )}
                </Stack>
              )}
            </Stack>
          </CardContent>
        </Card>
      </motion.div>

      {/* Full Media Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            backgroundColor: 'black',
            borderRadius: 2
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              color: 'white',
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 10
            }}
          >
            <CloseIcon />
          </IconButton>

          {selectedMedia?.endsWith('.mp4') || selectedMedia?.endsWith('.webm') ? (
            <Box
              component="video"
              src={selectedMedia}
              controls
              autoPlay
              sx={{
                maxWidth: '100%',
                maxHeight: '90vh'
              }}
            />
          ) : (
            <Box
              component="img"
              src={selectedMedia}
              alt="Review"
              sx={{
                maxWidth: '100%',
                maxHeight: '90vh'
              }}
            />
          )}
        </Box>
      </Modal>
    </>
  )
}
